import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { About, Footer, Skills, Testimonial, Work, Experience, Activities, Blogs, WhatIDo } from './container';
import { AllExperiences, AllProjects, AllActivities, AllBlogs } from './pages';
import { Navbar, SocialMedia } from './components';
import './App.scss';

const ScrollToHash = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Small timeout to ensure DOM is rendered before scrolling
      setTimeout(() => {
        const element = document.getElementById(hash.replace('#', ''));
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

const App = () => {
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light-mode');
  
  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.body.className = theme;
  }, [theme]);

  return (
      <div className={`app ${theme}`}>
        <BrowserRouter>
        <ScrollToHash />
        <Routes>
          {/* Main landing page */}
          <Route path="/" element={
            <>
              <Navbar theme={theme} onChangeValue={(newTheme) => setTheme(newTheme)} />
              <SocialMedia />
              <About />
              <WhatIDo />
              <Experience />
              <Work />
              <Skills />
              <Activities />
              <Blogs />
              <Testimonial />
              <Footer />
            </>
          } />
          
          {/* All experiences page */}
          <Route path="/all-experiences" element={
            <>
              <Navbar theme={theme} onChangeValue={(newTheme) => setTheme(newTheme)} />
              <AllExperiences />
              <Footer />
            </>
          } />

          {/* All projects page */}
          <Route path="/all-projects" element={
            <>
              <Navbar theme={theme} onChangeValue={(newTheme) => setTheme(newTheme)} />
              <AllProjects />
              <Footer />
            </>
          } />

          {/* All activities page */}
          <Route path="/all-activities" element={
            <>
              <Navbar theme={theme} onChangeValue={(newTheme) => setTheme(newTheme)} />
              <AllActivities />
              <Footer />
            </>
          } />

          {/* All blogs page */}
          <Route path="/all-blogs" element={
            <>
              <Navbar theme={theme} onChangeValue={(newTheme) => setTheme(newTheme)} />
              <AllBlogs />
              <Footer />
            </>
          } />
        </Routes>
        </BrowserRouter>  
      </div>
    
  );
}

export default App;